import { ChatCitation } from '../../../../domain/messages/models/ChatCitation';
import { AuthorRoles, ChatMessage, ChatMessageType, UserFeedback } from '../../../../domain/messages/models/ChatMessage';
import { ProGPTChatMessageDto, ProGPTCitationSourceDto } from '../dtos/responses/ProGPTChatMessageDto';


const mapAuthorRoleToFrontendRole = (authorRole: number): AuthorRoles => {
    switch (authorRole) {
        case 0:
            return AuthorRoles.User;
        case 1:
            return AuthorRoles.Bot;
        default:
            return AuthorRoles.User;
    }
};

const toTimestamp = (value?: string | number): number => {
    if (value === undefined || value === null) {
        return 0;
    }

    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

const mapUserFeedbackToFrontendValue = (userFeedback?: string): UserFeedback | undefined => {
    if (!userFeedback) {
        return undefined;
    }

    switch (userFeedback.toLowerCase()) {
        case 'positive':
            return UserFeedback.Positive;
        case 'negative':
            return UserFeedback.Negative;
        case 'requested':
            return UserFeedback.Requested;
        default:
            return UserFeedback.Unknown;
    }
};

export const mapToChatCitation = (citations: ProGPTCitationSourceDto[] | undefined): ChatCitation[] => {
    var formattedCitations: ChatCitation[] = [];
    if (!citations || citations.length == 0) return []
    citations.forEach(citation => {
        var formattedCitation: ChatCitation = { link: citation.link, title: citation.sourceName ?? '' }
        formattedCitations.push(formattedCitation);
    });
    return formattedCitations;
}

export const mapProGPTChatMessageDtoToModel = (dto: ProGPTChatMessageDto): ChatMessage => ({
    id: dto.id,
    chatId: dto.chatId,
    userName: dto.userName,
    content: dto.content,
    timestamp: toTimestamp(dto.timestamp),
    type: dto.type ?? ChatMessageType.Message,
    citations: mapToChatCitation(dto.citations),
    authorRole: mapAuthorRoleToFrontendRole(dto.authorRole),
    agentSources: dto.agentSources ?? [],
    modelId: dto.modelId,
    prompt: dto.userPrompt,
    userFeedback: mapUserFeedbackToFrontendValue(dto.userFeedback),
    tokenUsage: dto.tokenUsage,
});

